import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { SessionType } from '../sessions';

export type ExploreQuery = z.infer<typeof exploreQuerySchema>;

export const exploreQuerySchema = z.object({
  phaseTypeIds: z.array(z.uuid()).optional(),
  sessionTypes: z.array(z.enum(SessionType)).optional(),
  timeRange: z.object({
    from: isoDatetimeToDate,
    to: isoDatetimeToDate,
  }),
});
